if (typeof ImageTextVideo === 'undefined') {
  class ImageTextVideo extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('data-initialized')) {
      return;
    }

    this.setAttribute('data-initialized', 'true');
    this.trigger = this.querySelector('[data-video-trigger]');
    this.mediaFrame = this.querySelector('.image-text__media-frame');
    this.modal = this.querySelector('[data-video-modal]');
    this.content = this.closest('.image-text__content');
    this.overlay = this.querySelector('[data-video-overlay]');
    this.closeButton = this.querySelector('[data-video-close]');
    this.dialog = this.querySelector('[data-video-dialog]');
    this.video = this.querySelector('video');
    this.iframe = this.querySelector('[data-video-embed]');

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleFrameClick = this.handleFrameClick.bind(this);
    this.isOpen = false;

    if (this.trigger) {
      this.trigger.addEventListener('click', this.handleOpen);
    }
    if (this.mediaFrame) {
      this.mediaFrame.addEventListener('click', this.handleFrameClick);
    }
    if (this.overlay) {
      this.overlay.addEventListener('click', this.handleClose);
    }
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.handleClose);
    }
  }

  disconnectedCallback() {
    if (this.trigger) {
      this.trigger.removeEventListener('click', this.handleOpen);
    }
    if (this.mediaFrame) {
      this.mediaFrame.removeEventListener('click', this.handleFrameClick);
    }
    if (this.overlay) {
      this.overlay.removeEventListener('click', this.handleClose);
    }
    if (this.closeButton) {
      this.closeButton.removeEventListener('click', this.handleClose);
    }
  }

  handleOpen() {
    if (!this.modal) {
      return;
    }

    this.isOpen = true;
    if (this.content) {
      this.content.classList.add('is-video-open');
    }
    this.classList.add('is-video-open');
    if (this.playTimeout) {
      window.clearTimeout(this.playTimeout);
      this.playTimeout = null;
    }

    this.previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    this.modal.classList.add('is-open');

    this.playTimeout = window.setTimeout(() => {
      if (!this.isOpen) {
        return;
      }
      if (this.video) {
        this.video.currentTime = 0;
        const playPromise = this.video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      } else if (this.iframe) {
        const src = this.iframe.dataset.src;
        if (src) {
          const separator = src.includes('?') ? '&' : '?';
          this.iframe.src = `${src}${separator}autoplay=1`;
        }
      }
    }, 250);
  }

  handleFrameClick(event) {
    if (!this.trigger) {
      return;
    }
    if (event.target.closest('[data-video-trigger]')) {
      return;
    }
    this.handleOpen();
  }

  handleClose() {
    if (!this.modal) {
      return;
    }

    this.isOpen = false;
    if (this.content) {
      this.content.classList.remove('is-video-open');
    }
    this.classList.remove('is-video-open');
    if (this.playTimeout) {
      window.clearTimeout(this.playTimeout);
      this.playTimeout = null;
    }
    this.modal.classList.remove('is-open');
    document.body.style.overflow = this.previousOverflow || '';

    if (this.video) {
      this.video.pause();
      this.video.currentTime = 0;
    }
    if (this.iframe) {
      this.iframe.src = '';
    }
  }
}

  if (!customElements.get('image-text-video')) {
    customElements.define('image-text-video', ImageTextVideo);
  }
}
